import React from "react";
import { motion } from "framer-motion";
import { Briefcase, HeartHandshake, Rocket, Check } from "lucide-react";
import { DIVISIONS } from "@/data/content";

const ICONS = { business: Briefcase, family: HeartHandshake, projects: Rocket };
const ACCENT = { business: "#ff5c49", family: "#12b2a0", projects: "#ffc247" };

export const Divisions = () => {
  return (
    <section id="areas" className="py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <span className="text-xs font-semibold tracking-[0.25em] uppercase text-[#ff5c49]">
            Qué ofrecemos
          </span>
          <h2 className="font-display text-4xl md:text-5xl font-extrabold tracking-tight mt-4 leading-tight">
            Tres áreas, un mismo norte
          </h2>
          <p className="mt-5 text-lg text-[#6b6873] leading-relaxed">
            Acompañamos cada dimensión de tu vida y tu negocio con soluciones a la medida.
          </p>
        </div>

        <div className="mt-14 grid md:grid-cols-3 gap-6">
          {DIVISIONS.map((d, i) => {
            const Icon = ICONS[d.key];
            const accent = ACCENT[d.key];
            return (
              <motion.div
                key={d.key}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                data-testid={`division-${d.key}`}
                className="flex flex-col bg-white border border-[#e4dccf] rounded-3xl p-8 hover:-translate-y-1.5 hover:shadow-xl transition-all duration-300"
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center"
                  style={{ backgroundColor: `${accent}1a` }}
                >
                  <Icon className="w-6 h-6" style={{ color: accent }} />
                </div>
                <h3 className="font-display text-2xl font-extrabold mt-6">{d.name}</h3>
                <p className="mt-2 text-[#6b6873] leading-relaxed">{d.desc}</p>
                <ul className="mt-6 space-y-2.5 flex-1">
                  {d.items.map((it, idx) => (
                    <li key={idx} className="flex items-center gap-2.5 text-sm text-[#2b2a33]">
                      <Check className="w-4 h-4 shrink-0" style={{ color: accent }} />
                      {it}
                    </li>
                  ))}
                </ul>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
